export interface ICurrency {
  currencyDisplayName: string;
  currencyEnglishName: string;
  currencySymbol: string;
  iSOCurrencySymbol: string;
}
